import { useEffect, useState } from 'react';
import  styles from './style.module.css';
import General from './General';
import Users from './Users';
import { useRecoilState } from 'recoil';
import { namespaceState } from '../../recoil/atoms';
import InviteModal from './InviteModal';
import Approve from './Approve';
import { useActionData } from 'react-router';
import useApi from '../../services/useApi';

export default function NamespaceSettingGeneral(){
    const [selectedMenu,setSelectedMenu]=useState(0);
    const [nsState,setNsState]=useRecoilState(namespaceState);
    const [isInviteModal,setIsInviteModal]=useState(false);
    const [refreshList,setRefreshList]=useState(false);
    const [selectedUsers,setSelectedUsers]=useState([]);
    const adminRole="owner";

    const handleRequest=(params)=>{
        useApi.put('ngp/namespace/user/pending/apply/'+params+'?namespaceId='+nsState.id,{
            "namespaceUserDesc": "empty",
            "idList": selectedUsers.map(user=>user.id)
        }).then(res=>{
            setRefreshList(!refreshList)
        })
    }

    return(
        <>
        <div className={styles["wrap"]}>
            <div className={styles["header"]}>
                <span>Namespace Setting<p>&gt;</p> {nsState.namespaceName}</span>
            </div>
            <div className={styles["menu"]}>
                <div className={styles["tab"]}>
                    <div className={`${styles["tab-border"]} ${selectedMenu == 0 ? styles["tab-border-left"] : selectedMenu == 1 ? styles["tab-border-center"] : styles["tab-border-right"]}`}></div>
                    <span className={`${styles['tab-item']}`} onClick={()=>setSelectedMenu(0)}>General</span>
                    <span className={`${nsState.namespaceUserRoleName==adminRole?styles['tab-item']:styles['tab-item-off']}`} onClick={()=>setSelectedMenu(1)}>Users</span>
                    <span className={`${nsState.namespaceUserRoleName==adminRole?styles['tab-item']:styles['tab-item-off']}`} onClick={()=>setSelectedMenu(2)}>Approve</span>
                </div>
                {selectedMenu==1&&
                <div className={styles["invite-btn"]} onClick={()=>setIsInviteModal(true)}>
                    <div></div>
                    <span>Invite user</span>
                </div>
                }
                {(selectedMenu===2 && selectedUsers.length>0) &&
                <div className={styles["approve-btn-wrap"]}>
                    <div className={styles["decline-btn"]} onClick={()=>handleRequest("reject")}>
                        <div></div>
                        <span>Decline</span>
                    </div>
                    <div className={styles["approve-btn"]} onClick={()=>handleRequest("approve")}>
                        <div></div>
                        <span>Approve Request</span>
                    </div>
                </div>
                }
            </div>
            <div className={styles["body"]}>
                {selectedMenu===0?
                <General/>:
                selectedMenu===1?
                <Users refreshList={refreshList}/>
                :
                <Approve 
                refreshList={refreshList} 
                onChangeUsers={(users)=>setSelectedUsers(users)}
                />
                }
            </div>
        </div>
        {isInviteModal&&
        <InviteModal
        onClose={()=>setIsInviteModal(false)}
        onRefreshList={()=>setRefreshList(!refreshList)}
        />
        }
        </>
    )
}